import ReviewItem from './Component';

export default ReviewItem;